import { useEffect, useState } from "react";

import { getBettoPlaceholderCount } from "./getBettoGridColumnCount.js";

const getCountForViewport = (cardVariant) =>
	getBettoPlaceholderCount(typeof window !== "undefined" ? window.innerWidth : 1440, cardVariant);

export const useBettoPlaceholderCount = (cardVariant) => {
	const [count, setCount] = useState(() => getCountForViewport(cardVariant));

	useEffect(() => {
		const updateCount = () => {
			const nextCount = getBettoPlaceholderCount(window.innerWidth, cardVariant);
			setCount((current) => (current === nextCount ? current : nextCount));
		};

		updateCount();
		window.addEventListener("resize", updateCount, { passive: true });

		return () => window.removeEventListener("resize", updateCount);
	}, [cardVariant]);

	return count;
};
